<template>
  <v-content v-if="loggedin">
    <v-container fluid>
      <Header :title="'Dashboard'" />
      <v-row v-if='Object.keys(currentUser).length !=0  && (currentUser.roles.includes(1) || currentUser.roles.includes(3))'>
        <v-col cols='12' md='3' sm='12'>
          <v-autocomplete
              v-model="selectedGroups"
              :items="groups"
              item-value="group_id"
              item-text="group_name"
              :label="'Groups' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              @change="changedGroup"
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-checkbox @change="checkboxUpdated('groups')" v-model="checkAllGroups" label="All"></v-checkbox>
              </v-list-item>
            </template>  
            </v-autocomplete>
        </v-col> 
        <v-col cols='12' md='3' sm='12'>
          <v-autocomplete
              v-model="selectedCourses"
              :items="courses"
              item-value="course_id"
              item-text="course_name"
              :label="'Courses' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(ischangeGroupApi? true : false)"
            >
          <template v-slot:prepend-item>
            <v-list-item>
                <v-checkbox @change="checkboxUpdated('courses')" v-model="checkAllCourses" label="All"></v-checkbox>
            </v-list-item>
          </template>              
            
            </v-autocomplete>
        </v-col>
        <v-col cols='12' md='3' sm='12'>
          <v-autocomplete
              v-model="selectedUsers"
              :items="users"
              item-value="user_id"
              :item-text="item =>`${item.name} (${item.email})`"
              :label="'Users' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(ischangeGroupApi? true : false)"
            >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-checkbox @change="checkboxUpdated('users')" v-model="checkAllUsers" label="All"></v-checkbox>
            </v-list-item>
          </template>            
            
            </v-autocomplete>
        </v-col>        
        <v-col cols='12' md='3' sm='12'>
          <v-row class="mt-n3">
            <v-col cols="12" md="6" sm="12">
              <v-btn :disabled="(ischangeGroupApi? true : false)" class="white--text" small :color="primary_color" @click="getDashboardData()"  x-large block>
                {{ 'Search' | translate }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn :disabled="(ischangeGroupApi? true : false)" class="white--text" small :color="primary_color" @click="clearFilter()"  x-large block>
                {{ 'Reset' | translate }}
              </v-btn>
            </v-col>
          </v-row>
             
        </v-col>
      </v-row>  
      <template v-if="adminSearch">
          <v-dialog v-model="adminSearch" persistent fullscreen content-class="loading-dialog">
            <v-container fill-height>
              <v-layout row justify-center align-center>
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </v-layout>
            </v-container>
          </v-dialog>
      </template>
      <template v-else-if="!adminSearch">
      <v-row v-if="isSearching && Object.keys(dashboardstats).length >0" class="mt-n3 mb-2">
        <v-col cols="12" md="7">
          <h3>
            {{$t('dashboardstats', {users:dashboardstats.tot_users, userstat:(dashboardstats.tot_users == 1 ? (curLanguage.lang_code == 'de' ? ' Nutzer' : 'user' ) : (curLanguage.lang_code == 'de' ? 'Nutzer' : 'users' )),courses: dashboardstats.tot_courses, coursesstat: (dashboardstats.tot_courses == 1 ? (curLanguage.lang_code == 'de' ? 'Kurs' : 'course' ) : (curLanguage.lang_code == 'de' ? 'Kurse' : 'courses' )) }) }}
          </h3>
        </v-col>
        <v-col cols="12" md="3" class="text-right">
          <h3>{{ 'Subscribed' | translate }} {{ ':'+dashboardstats.subscribed_percent+'%'}} </h3>
        </v-col>
        <v-col cols="12" md="2" class="text-right">
          <h3>{{ 'Passed' | translate }}{{ ':'+dashboardstats.passed_percent+'%'}} </h3>
        </v-col>
        <v-col cols="12"><v-divider></v-divider></v-col>
        
      </v-row>      
      <template v-if="coursesdata.length >0">
      <v-row v-for="(courses, courseindex) of coursesdata" :key="courseindex">
        <v-col cols="12" sm="12" md="12" class="pt-0">
              <h3 class="mb-5">{{ courses.course_name }}</h3>
              <v-expansion-panels v-model="openedDocumentPanel[courses.course_id]" v-if="isSearching ==false">
                <v-expansion-panel class="mb-5">
                <v-expansion-panel-header @click="openDocumentPanel('search'+courses.course_id,courses.course_id)">
                  {{ 'Learning material' | translate }}
                  </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6" offset-md="6">
                      <v-text-field
                        outlined
                        autocomplete="off"
                        :label="'Search learning material' | translate"
                        :ref="'search'+courses.course_id"
                        @keyup="openDocumentPanel('search'+courses.course_id,courses.course_id)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-sheet
                    class="mx-auto"
                    v-if="(dashboarddocuments.hasOwnProperty(courses.course_id) ? (dashboarddocuments[courses.course_id].length >0 ? true : (loadingdata ==false ? true : false) ): false )"
                  >
                    <v-slide-group
                      class="pa-4"
                      show-arrows
                    >
                      <v-slide-item
                        v-for="(documentdata,documentindex) of dashboarddocuments[courses.course_id]" 
                        :key="documentindex+''+documentdata.gendoc_id+''+documentdata.course_id"
                      >
                        <v-card
                          class="ma-4 pa-1"
                          width="200"
                        >
                          <v-row>
                            <v-col cols="12"
                              class="fill-height"
                              align="center"
                              justify="center">
                            <v-icon
                              size="60"
                              v-text="'mdi-file-document'"
                            ></v-icon>
                            </v-col>
                          </v-row>
                          <v-card-title class="text-center" style="height:85px;" v-if="documentdata.gendoc_description.length <=30">
                            {{ documentdata.gendoc_name }}
                          </v-card-title>
                          <v-card-title class="text-center" style="height:85px;" v-else-if="documentdata.gendoc_description.length >30">{{ documentdata.gendoc_name | readMore(30, '...') }}</v-card-title>
                          <v-card-subtitle class="text-center mt-2 mb-2" style="height:40px;">
                            <v-list-item-content class="pt-0">
                              <v-list-item-title class="pt-0"><b style="font-size: 14px;color: darkgray;font-weight: 700;">{{ (documentdata.section_headers.length > 0 ? documentdata.section_headers[0].section_name :'Undefined'  ) | translate }}</b>
                                    <v-tooltip v-if='documentdata.section_headers.length  > 1' bottom>
                                    <template v-slot:activator="{ on }">
                                      <br />
                                      <span v-on="on" class="mt-2" style="font-size: 14px;color: darkgray;font-weight: 700;">{{ '& others' | translate }}</span>
                                    </template>
                                    <p v-for="(sectionheaders,index) in documentdata.section_headers" :key="index+sectionheaders+sectionheaders.section_id" ><span v-if='index !== 0'><span>{{ sectionheaders.section_name }}</span></span></p>
                                  </v-tooltip>
                                </v-list-item-title>
                            </v-list-item-content>                          
                          </v-card-subtitle>  
                          <v-card-text style="height: 50px;" v-if="documentdata.gendoc_description.length <=40">
                           {{ documentdata.gendoc_description }}
                          </v-card-text>
                          <v-card-text style="height: 50px;" v-else-if="documentdata.gendoc_description.length >40">
                            {{ documentdata.gendoc_description | readMore(40, '...') }}
                          </v-card-text>
                          <v-card-actions class="justify-center">
                              <v-btn class="white--text" :color="primary_color" rel="noopener noreferrer" target="_blank" small :to="'/learningmaterial/'+documentdata.hash_id">{{ 'Details new' | translate}}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-sheet>
                  <h3 v-else-if="loadingdata==false && routerenter==false">{{ 'No data found' | translate }}</h3>
                </v-expansion-panel-content>
                </v-expansion-panel>                
              </v-expansion-panels>

              <v-expansion-panels  v-model="openedPanel[courseindex]" multiple accordion>
                <template v-for="(moduledata,moduleindex) of courses.company_modules">
                <v-expansion-panel v-if="moduledata.is_subscribed" expandable :key="courseindex+''+moduleindex"   :value="moduleindex"  class="mb-5">
                <v-expansion-panel-header class="pa-0 nonfocus">
                  <v-row>
                    <v-col cols="4" md="2" class="pt-9 text-center username" v-if="moduledata.hasOwnProperty('user_name')" v-on:click.stop="getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id, (moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">{{ moduledata.user_name }}</v-col>
                    <v-col cols="4" md="2" class="pt-9 text-center play-button" v-else v-on:click.stop="play(moduledata.module_id)"><v-btn class="white--text mt-n1" :color="primary_color"><v-icon color="#fff" class="mr-2">mdi-play-circle</v-icon>{{ 'Play' | translate }}</v-btn></v-col>
                    <v-col cols="12" md="6" class="pt-11  module-title" v-on:click.stop="getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''), 'to'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">{{ moduledata.title }}</v-col>
                    <v-col cols="4" md="2" class="pt-7 pb-7 text-center timespent" v-bind:style="{'background-color':'#f7f7f7'}" v-on:click.stop="getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''), 'to'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))"><h4 class="pb-2">{{ 'Time Spent' | translate }}</h4>{{ moduledata.time_spent }}</v-col>
                    <v-col cols="4" md="2" class="pt-9 text-center progress" v-bind:style="{'background-color':primary_color}" v-on:click.stop="getQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">
                      <h4 class="mt-n2 white--text">{{ 'Progress & Attempts' | translate }}</h4>
                      <v-progress-circular
                        :rotate="360"
                        :size="40"
                        :width="4"
                        class="mt-2"
                        :value="moduledata.module_progress"
                        color="white"
                        v-if="moduledata.is_passed == false"
                      >
                        {{ moduledata.module_progress+ '%' }}
                      </v-progress-circular>      
                      <v-icon
                        color="success"
                        size="35"
                        class="mt-2"
                        v-text="'mdi-checkbox-marked-circle'"
                        v-else
                      ></v-icon>              
                    </v-col>
                  </v-row>
                <template v-slot:actions>
                    <v-icon class="pb-10 pt-10 pl-4 pr-4" v-on:click.stop="closePanel(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">$expand</v-icon>
                </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content 
                v-bind:style=" 
                ( activeData.hasOwnProperty(courses.course_id) ? 
                (activeData[courses.course_id][moduleindex] == 'quiz' ? 
                 {'border':'4px solid '+primary_color} : 
                  {'background-color':'#f7f7f7'}):
                 '')      " >
                 <v-row v-if="timesessiondata.hasOwnProperty(courses.course_id)" class="pt-4 mb-n4">
                    <v-col cols="12" md="2" class="text-center">
                      <h3 class="mt-3">{{ ( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'Your sessions'  : 'Your attempts'  ):'') | translate }}</h3>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-menu
                        ref="menu"
                        v-model="menu['from'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''  )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        bottom
                        
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :label="'From' | translate"
                            name="from"
                            :value="curLanguage.lang_code=='de'? toGerman(date['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]) :date['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                            @input="saveChangedDate('from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))"
                            prepend-icon="mdi-calendar"
                            :ref="'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')"
                            autocomplete="off"
                            outlined
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                          no-title
                          scrollable
                          :locale="curLanguage.lang_code"
                          :max="date['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                          @input="menu['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')] = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-menu
                        ref="menuto"
                        v-model="menu['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                        :close-on-content-click="true"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :label="'To' | translate"
                            :ref="'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')"
                            prepend-icon="mdi-calendar"
                            :value="curLanguage.lang_code=='de'? toGerman(date['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]) :date['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                            @input="saveChangedDate('to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))"
                            autocomplete="off"
                            outlined
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''  )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                          no-title
                          scrollable
                          :min="date['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                          :locale="curLanguage.lang_code"
                          @input="menu['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')] = false"
                        >
                        </v-date-picker>
                      </v-menu>

                    </v-col>  
                    <v-col cols="12" md="3" >
                        <v-btn class="mt-2  white--text"  :color="primary_color" @click="( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ?getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')): getQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))):'')" >{{ 'Check' | translate}}</v-btn>
                        <v-btn class="mt-2 white--text"  :color="primary_color"  @click="( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ?clearTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')): clearQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''  )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))):'')">{{ 'Clear' | translate}}</v-btn>
                    </v-col>                     
                    <v-col cols="12" md="1" >
                    </v-col>                                      
                  </v-row> 
                  
                  <v-sheet
                    class="mx-auto"
                    style="'background-color':'#f7f7f7'"
                    v-if="(timesessiondata.hasOwnProperty(courses.course_id) ==true ?   timesessiondata[courses.course_id].hasOwnProperty(moduleindex) ==true ? timesessiondata[courses.course_id][moduleindex].length > 0  ? true : false : false : false )"
                  >
                    <v-slide-group
                      class="pa-4"
                      show-arrows
                v-bind:style=" 
                ( activeData.hasOwnProperty(courses.course_id) ? 
                (activeData[courses.course_id][moduleindex] == 'time' ? 
                  {'background-color':'#f7f7f7'}:''): 
                 '')      "

                    >
                      <v-slide-item
                        v-for="(time,timeindex) of timesessiondata[courses.course_id][moduleindex]"
                        :key="timeindex"
                      >
                        <v-card
                          class="ma-4 pa-2"
                          width="220"
                          v-if="time.hasOwnProperty('statement_query') == true"
                        >
                        <v-row
                          align="center"
                          justify="center"
                        >
                            <v-icon
                              color="success"
                              size="60"
                              class="pb-2"
                              v-text="'mdi-checkbox-marked-circle'"
                              v-if="time.statement_query == 'passed'"
                            ></v-icon>
                            <v-icon
                              color="yellow darken-1"
                              size="60"
                              class="pb-2"
                              v-text="'mdi-book'"
                              v-else-if="time.statement_query == 'attempted'"
                            ></v-icon>
                            <v-icon
                              color="red accent-3"
                              size="60"
                              class="pb-2"
                              v-text="'mdi-exclamation'"
                              v-else
                            ></v-icon>

                        </v-row>
                        <v-card-title>{{ time.statement_query | translate }}</v-card-title>
                        <v-card-text>
                          {{ 'Attempted on' | translate }}{{ ': '+(curLanguage.lang_code == 'de' ? moment(time.stored_at).format('DD.MM.YYYY hh:mm:ss') : time.stored_at )}}
                        </v-card-text>
                          <v-card-actions class="justify-center">
                              <v-btn class="white--text" :color="primary_color" small @click="details(courses.course_id, moduleindex, timeindex, time.statement_query)">{{ 'Details new' | translate}}</v-btn>
                          </v-card-actions>                          

                        </v-card>
                        <v-card
                          class="ma-4 pa-2"
                          width="220"
                          v-else
                        >
                        <v-card-title>{{ time.session_length}}</v-card-title>
                        <v-card-text>
                          <v-row>
                          <v-col cols="6">
                            {{ 'From' | translate }}<br />
                            {{ curLanguage.lang_code == 'de' ? moment(time.start_time).format('DD.MM.YYYY hh:mm:ss') : time.start_time }}
                          </v-col>
                          <v-col cols="6">
                            {{ 'To' | translate }}<br />
                            {{ curLanguage.lang_code == 'de' ? moment(time.end_time).format('DD.MM.YYYY hh:mm:ss')  : time.end_time }}
                          </v-col>
                          </v-row>
                        </v-card-text>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-sheet>
                  <h3 v-else-if="loadingdata == false &&routerenter ==false">{{ 'No data found' | translate }}</h3>
                </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-else-if="moduledata.is_subscribed==false" :key="courseindex+''+moduleindex"   :value="moduleindex"  class="mb-5">
                  <v-expansion-panel-header class="pa-0 nonfocus">
                    <v-row>
                      <v-col cols="4" md="2" class="pt-10 pb-6 text-center username " v-if="moduledata.hasOwnProperty('user_name')">{{ moduledata.user_name }}</v-col>
                      <v-col cols="12" md="6" class="pt-6 pb-7 mt-4 module-title ">{{ moduledata.title }}</v-col>
                      <v-col cols="4" md="2" class="pt-6 pb-7 text-center"></v-col>
                      <v-col cols="3" md="2" class="pt-6 pb-7 text-center "><v-chip class="ma-2 ml-n6" style="color:white;" :color="primary_color">{{ 'Not subscribed' | translate }}</v-chip></v-col>
                    </v-row>
                <template v-slot:actions>
                    <v-icon class="pb-10 pt-10 pl-4 pr-4">{{ '' }}</v-icon>
                </template>

                  </v-expansion-panel-header>
                </v-expansion-panel>
                </template>
              </v-expansion-panels>
        </v-col>
      </v-row>
      </template>
      <template v-else-if="coursesdata.length == 0  && loadingdata==false && routerenter ==false ">
          <v-row align="center"
              justify="center">
              <v-col>
                <h2 v-if="(selectedCourses.length > 0  || selectedUsers.length > 0 || selectedGroups.length > 0) &&  (this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3))">{{  'No subscribed courses found'  | translate }}</h2>
                <h2 v-else>
                  {{'Please subscribe to a course' | translate}} 
                  <v-btn small :color="primary_color" @click="goToCourse()" class="white--text" >
                    {{'Go to courses' | translate}}
                  </v-btn>
                </h2>
              </v-col>
          </v-row>
      </template>
      </template>
    </v-container>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <DataTable
                :title="quizdetailtitle"
                :headers="quizdetailheaders"
                :items="quizdetaildata"
                :search="quizdetailsearch"
                :footerstatus='footerstatus'
              />
            </v-col>
          </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" text @click="dialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'
import store from "@/store";
import {
  FETCH_DASHBOARD_DATA,
  FETCH_DASHBOARD_DOCUMENTS,
  FETCH_DASHBOARD_QUIZ_DATA,
  FETCH_TIME_DATA,
  FETCH_COURSES,
  FETCH_USERS,
  FETCH_GROUPS,
  FETCH_DASHBOARD_STATS_DATA,
  RESET_STATE
} from "@/store/actions.type";
import { RESET_COURSES_DATA,SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";

export default {
  name: "Dashboard",
  beforeRouteEnter(to, from, next) {
      store.dispatch(RESET_STATE)
    if (store.state.auth.user.roles.includes(1) || store.state.auth.user.roles.includes(3)) {
      Promise.all([
        store.dispatch(FETCH_GROUPS, ""),
        store.dispatch(FETCH_COURSES, ''),
        store.dispatch(FETCH_USERS, "")
      ]).finally(()=>{
          store.commit(SET_LOADING, false)
                  
      })
    }
    return next();
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Header: () => import("@/components/header/Header"),
  },  

  computed: {
    ...mapGetters(["coursesdata",'dashboardstats',"timesessiondata","dashboarddocuments", "users", "courses","currentUser","loadingdata",'routerenter','curLanguage','loggedin','groups','videotutorialdata']),    
  },
  mounted(){
    this.getDashboardData();
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color
  },
  data: function() {
   return {
      date: [],
      menu: [],
      moment:moment,
      openedDocumentPanel:[],
      openedPanel: {},
      selectedUsers: [],
      selectedCourses: [],
      selectedGroups: [],
      primary_color: '',
      activeData:{},
      quizdetailsearch: "",
      footerstatus: 'false',
      quizdetailheaders: [],
      quizdetailtitle: 'Module details',
      dialog: false,   
      quizdetaildata: [], 
      isSearching: false,
      adminSearch: false,
      ischangeGroupApi: false,
      checkAllGroups: false,
      checkAllCourses: false,
      checkAllUsers: false,
    };
  },
  methods: {
    async clearFilter(){
      this.checkAllGroups = false
      this.checkAllCourses = false
      this.checkAllUsers = false      
      this.selectedGroups = []
      this.selectedCourses = []
      this.selectedUsers = []
      await this.changedGroup()
      await this.getDashboardData()
    },
    checkboxUpdated(flag){
      if(flag == "groups" && this.checkAllGroups){
          this.selectedGroups = []
          this.selectedGroups = this.groups.map(data=>data.group_id)
          this.selectedUsers = []
          this.selectedCourses = []
          this.checkAllCourses = false
          this.checkAllUsers = false   
          this.changedGroup()
      }
      else if(flag=="groups" && this.checkAllGroups == false){
        this.selectedGroups = []
        this.selectedUsers = []
        this.selectedCourses = []
        this.checkAllCourses = false
        this.checkAllUsers = false   
        this.changedGroup()
      }
      else if(flag== "courses" && this.checkAllCourses){
        this.selectedCourses = []
        this.selectedCourses = this.courses.map(data=>data.course_id)
      }
      else if(flag== "courses" && this.checkAllCourses == false){
        this.selectedCourses = []
      }
      else if(flag == "users" && this.checkAllUsers){
        this.selectedUsers = []
        this.selectedUsers = this.users.map(data=>data.user_id)        
      }
      else if(flag== "users" && this.checkAllUsers == false){
        this.selectedUsers = []
      }

    },
    async changedGroup(){
      this.ischangeGroupApi = true
      await this.$store.dispatch(FETCH_COURSES,'?group_ids='+this.selectedGroups)
      await this.$store.dispatch(FETCH_USERS,'?group_ids='+this.selectedGroups)
      this.$store.commit(SET_LOADING, false)
      this.ischangeGroupApi = false
    },
    goToCourse(){
      this.$router.push('/courses')
    },
    toGerman(datevalue){
      if((typeof datevalue !== 'undefined') && (datevalue !== null)){
        let [year, month, day] = datevalue.split('-')
        return [day,month,year].join('.')
      }
      else{
        return ''
      }
    },
    saveChangedDate(idkey){
      if(this.curLanguage.lang_code == 'en'){  
          this.date[idkey]=this.$refs[idkey][0].internalValue  
      }
      else{
        if(typeof this.$refs[idkey][0].internalValue !== 'undefined' && this.$refs[idkey][0].internalValue !== null){
          let [day,month,year] = this.$refs[idkey][0].internalValue.split('.')
          if(isNaN(Date.parse(year+'-'+month+'-'+day))== false){
            this.date[idkey]=year+'-'+month+'-'+day
          }
        }
      }
    },
    async clearTime(courseindex,moduleindex,moduleid, course_id, userid,from,to){

      (this.$refs[from] != undefined ? (this.date[from] =null,this.$refs[from][0].internalValue =null): null);
      (this.$refs[to] != undefined ? (this.date[to]=null,this.$refs[to][0].internalValue =null): null);

      this.getTime(courseindex,moduleindex,moduleid, course_id, userid,from,to)
    },
    async clearQuizData(courseindex,moduleindex,moduleid, course_id, userid,from,to){
      (this.$refs[from] != undefined ? (this.date[from] = null, this.$refs[from][0].internalValue =null): null);
      (this.$refs[to] != undefined ? (this.date[to]= null, this.$refs[to][0].internalValue =null): null);
    
      this.getQuizData(courseindex,moduleindex,moduleid, course_id, userid,from,to)
    },
    async getTime(courseindex,moduleindex,moduleid, course_id, userid,from,to){
      await store.commit(SET_LOADING, true)
      if(this.activeData.hasOwnProperty(course_id) == false){
        this.activeData[course_id] = {}
      }
      this.activeData[course_id][moduleindex] = 'time'      

      await this.$store.dispatch(FETCH_TIME_DATA,{moduleid: moduleid, moduleindex:moduleindex, course_id:course_id, userid:userid, fromdate: (this.date[from] == undefined ? '':  this.date[from]  ), todate: (this.date[to] == undefined ? '' :this.date[to] )}).then(()=>{
        this.$store.commit(SET_LOADING, false)
        this.openPanel(courseindex,moduleindex)
      })
    },
    details(courseid,moduleindex,index, query) {
        if(query == 'attempted'){
          this.quizdetailheaders= [
            {text: this.$t("Your score"), value:'result.score.raw'},
            {text: this.$t("Max Score"), value:'result.score.max'},
            {text: this.$t("Time taken"), value:'result.seconds'},
            {text: this.$t("Pass Score"), value:'pass_score'},
          ]  
        }
        else{
          this.quizdetailheaders= [
            {text: this.$t("Your score"), value:'result.score.raw'},
            {text: this.$t("Max Score"), value:'result.score.max'},
            {text: this.$t("Time taken"), value:'result.seconds'},
            {text: this.$t("Status"), value:'statement_query'},
          ]   
        }
        this.quizdetaildata = [this.timesessiondata[courseid][moduleindex][index]]
        this.dialog = true
    },
    async getQuizData(courseindex,moduleindex,moduleid, course_id,userid,from,to){
      await store.commit(SET_LOADING, true)
      if(this.activeData.hasOwnProperty(course_id) == false){
        this.activeData[course_id] = {}
      }      
      this.activeData[course_id][moduleindex] = 'quiz'      
      await this.$store.dispatch(FETCH_DASHBOARD_QUIZ_DATA,{moduleid: moduleid, moduleindex:moduleindex, course_id:course_id, userid:userid, fromdate: (this.date[from] == undefined ? '':  this.date[from]  ), todate: (this.date[to] == undefined ? '' :this.date[to] )}).then(()=>{
        this.$store.commit(SET_LOADING, false)
        this.openPanel(courseindex,moduleindex)
      })
    },    
    async getDashboardData(){
      await this.$store.commit(RESET_COURSES_DATA)
      this.openedDocumentPanel=[]
      this.openedPanel = {}
      this.activeData = {}

      if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3)){
        let selectedusers = []
        let selectedcourses = []

        if(this.selectedGroups.length ==0 && this.selectedUsers == 0 && this.selectedCourses == 0){
          selectedcourses = []
          selectedusers = []
        }
        else{
          if(this.selectedUsers.length == 0){
            selectedusers = this.users.map(data=>data.user_id)
          }
          else{
            selectedusers = this.selectedUsers
          }

          if(this.selectedCourses.length == 0){
            selectedcourses =this.courses.map(data=>data.course_id)
          }
          else{
            selectedcourses = this.selectedCourses
          }
        }


        if(this.selectedUsers.length >0 || this.selectedGroups.length >0 || this.selectedCourses.length >0){
          this.isSearching = true
        }
        else{
          this.isSearching = false
        }

        this.adminSearch = true

        await Promise.all([
          await this.$store.dispatch(FETCH_DASHBOARD_DATA,'subscribed-courses?course_ids='+selectedcourses+'&user_ids='+selectedusers),
          (selectedcourses.length >0 || selectedusers.length >0 ?await this.$store.dispatch(FETCH_DASHBOARD_STATS_DATA,'show-statistics?course_ids='+selectedcourses+'&user_ids='+selectedusers): ''),
          ]).then(()=>{
          this.$store.commit(SET_LOADING, false)
          store.commit(SET_ROUTER_ENTER, false)
          let coursedatalength= this.coursesdata.length
          let i=0;
          while(i<coursedatalength){
            this.$set(this.openedPanel,i,[])
            i++;
          }
          this.adminSearch = false
          store.commit(SET_ROUTER_ENTER, false)
        })

      }
      else{
        await this.$store.dispatch(FETCH_DASHBOARD_DATA,'subscribed-courses').then(() => {
          this.$store.commit(SET_LOADING, false)
          store.commit(SET_ROUTER_ENTER, false)
          let coursedatalength= this.coursesdata.length
          let i=0;
          while(i<coursedatalength){
            this.$set(this.openedPanel,i,[])
            i++;
          }
          this.adminSearch = false
          store.commit(SET_ROUTER_ENTER, false)
        })
      }
    },
    openPanel(courseindex,moduleindex){
      if(this.openedPanel[courseindex].indexOf(moduleindex) == -1){
        this.openedPanel[courseindex].push(moduleindex)
      }
    },
    async openDocumentPanel(searchvalue,courseid){
      let searchdata = (this.$refs[searchvalue] == undefined ? '': (this.$refs[searchvalue][0].internalValue == undefined ? '' :this.$refs[searchvalue][0].internalValue))
      await this.$store.dispatch(FETCH_DASHBOARD_DOCUMENTS,{course_id: courseid, search: searchdata}).then(() => {
        this.$store.commit(SET_LOADING, false)
        if(this.openedDocumentPanel.indexOf(courseid) == -1){
          this.openedDocumentPanel.push(courseid)
        }
      })        
    },
    closePanel(courseindex,moduleindex,moduleid,courseid,userid){
      if(this.openedPanel[courseindex].indexOf(moduleindex) >=0){
        this.openedPanel[courseindex] = this.openedPanel[courseindex].filter(item => item!=moduleindex)
      }
      else{
        this.openPanel(courseindex,moduleindex)
        this.clearTime(courseindex,moduleindex,moduleid, courseid, userid)
      }
    },
    play(id) {
      this.$router.push("/moduleplayer/" + id)
    },
  }
};
</script>
<style scoped>
.v-expansion-panel-header:before {
    background-color: #ffffff !important;
}

.nonfocus{
  background: #ffffff !important;
}

.nonfocus:focus{
  background: #ffffff !important;
}
@media (min-width: 300px) and (max-width: 960px) {
  .module-title{
    order:1;
  }
  .username{
    order:2;
  }
  .play-button{
    order:2;
  }
  .timespent{
    order:3;
  }
  .progress{
    order:4;
  }
}
</style>